export default __webpack_public_path__ + "static/media/Facebook.1a707b6f.svg";